import gsap from 'gsap';
import Swiper, {
	Pagination,
	Autoplay,
	Navigation,
	Keyboard,
} from 'swiper';

let swiperFormation;

//-------------------//
// Animation enter in the page
//-------------------//

const enableSwiperFormation = function () {
	// init swiper
	const swiperFormationWrapper =
		document.querySelectorAll('.swiper-formations');

	if (swiperFormationWrapper !== null) {
		swiperFormationWrapper.forEach(element => {
			var tl = new gsap.timeline();
			tl.fromTo(
				element.querySelectorAll('.swiper-slide a'),
				0.7,
				{ alpha: 0, y: 'random( 20, 20)' },
				{ alpha: 1, y: 0, stagger: 0.2 },
				0.2
			),
				tl.fromTo(
					element.querySelectorAll('.swiper-slide .heading'),
					0.7,
					{ alpha: 0, y: '10px' },
					{ alpha: 1, y: 0, stagger: 0.2 },
					0.3
				);

			let btnProgramme = element.querySelector('.formations-list-btn');

			swiperFormation = new Swiper(element, {
				modules: [Pagination, Autoplay, Navigation, Keyboard],
				pagination: {
					el: element.querySelector('.swiper-pagination'),
					clickable: true,
				},
				keyboard: {
					enabled: true,
					onlyInViewport: false,
				},
				speed: 500,
				loop: true,
				slidesPerView: 'auto',
				autoplay: 3000,
				centeredSlides: true,

				autoplayDisableOnInteraction: false,
				grabCursor: true,
				navigation: {
					nextEl: element.querySelector('.swiper-button-next'),
					prevEl: element.querySelector('.swiper-button-prev'),
				},
				breakpoints: {
					// when window width is >= 640px
					767: {
						slidesPerView: 2,
						loop: false,
						centeredSlides: false,
					},
					991: {
						slidesPerView: 3,
						centeredSlides: true,
					},

					1200: {
						slidesPerView: 4,
						centeredSlides: false,
					},
				},
				on: {
					init: function () {
						let slideLink = element
							.querySelector('.swiper-slide-active a')
							.getAttribute('href');

						if (btnProgramme) {
							btnProgramme.setAttribute('href', slideLink);
						}
					},

					slideChangeTransitionEnd: function () {
						let slideLink = element
							.querySelector('.swiper-slide-active a')
							.getAttribute('href');
						if (btnProgramme) {
							btnProgramme.setAttribute('href', slideLink);
						}
					},
				},
			});
		});
	}
};

export { enableSwiperFormation, swiperFormation };
